var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "insidelands--template" }, [
    _c(
      "h1",
      {
        staticClass: "absolute mv0 tc h1 w1 transparent",
        staticStyle: { color: "transparent" },
      },
      [_vm._v(_vm._s(_vm.page.title))]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "relative container-fluid pt4 pb5 pt5-ns pb6-ns" },
      [
        _vm.page.intro_section && _vm.page.intro_section.is_published
          ? _c(
              "section",
              {
                staticClass: "db relative center mw7",
                attrs: { id: _vm.page.intro_section.id },
              },
              [
                _vm.page.logo_lockup_image
                  ? _c("img", {
                      staticClass: "db relative center mw7",
                      attrs: {
                        src: _vm.page.logo_lockup_image,
                        alt: "Inside Lands : Aug 28-29 2020 - Presented By Outside Lands",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.page.intro_section.header
                  ? _c(
                      "h2",
                      {
                        staticClass:
                          "mt5 tc ttu f2 f2-ns is-lorano-bold is-green",
                      },
                      [_vm._v(_vm._s(_vm.page.intro_section.header))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "relative mt4 f3 lh-copy tc is-tablet-semicond-bold is-green",
                  domProps: {
                    innerHTML: _vm._s(_vm.marked(_vm.page.intro_section.text)),
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: _vm.page.intro_section.twitch.image,
                      expression: "page.intro_section.twitch.image",
                    },
                  ],
                  staticClass: "db relative center w-100 mt4 mw6",
                }),
                _vm._v(" "),
                _vm.page.intro_section.twitch.text
                  ? _c("div", {
                      staticClass:
                        "mt4 tc ttn f3 f2-ns is-tablet-semicond-bold lh-copy is-green",
                      domProps: {
                        innerHTML: _vm._s(_vm.page.intro_section.twitch.text),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page.schedule_section && _vm.page.schedule_section.is_published
          ? _c(
              "section",
              {
                staticClass: "db relative center mw8 pv3",
                attrs: { id: _vm.page.schedule_section.id },
              },
              [
                _vm.page.schedule_section.title
                  ? _c(
                      "h2",
                      { staticClass: "mt5 tc ttu f-4 f-4-ns is-blenny is-red" },
                      [_vm._v(_vm._s(_vm.page.schedule_section.title))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row mt3" },
                  _vm._l(
                    _vm.page.schedule_section.schedules,
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: "schedule-" + _vm.scheduleDay(index),
                          staticClass: "col-xs-12 col-md-6 mv4 mv3-ns",
                        },
                        [
                          _c(
                            "h3",
                            { staticClass: "mb2 tc ttu f1 is-blenny is-red" },
                            [_vm._v(_vm._s(_vm.scheduleDay(index)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "db relative pointer mt2 mt3-ns grow ph0 ph2-ns",
                              attrs: {
                                href: item.link,
                                target: "_blank",
                                title: item.title + " Schedule",
                              },
                            },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: item.image,
                                    expression: "item.image",
                                  },
                                ],
                                attrs: { title: item.title },
                              }),
                            ]
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _vm.page.schedule_section && _vm.page.schedule_section.text
                  ? _c("div", {
                      staticClass:
                        "mt4 tc ttn f3 is-tablet-semicond-bold lh-copy is-green",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.marked(_vm.page.schedule_section.text)
                        ),
                      },
                    })
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page.lineup_section && _vm.page.lineup_section.is_published
          ? _c(
              "section",
              {
                staticClass: "db relative center mw7 pv3",
                attrs: { id: _vm.page.lineup_section.id },
              },
              [
                _vm.page.lineup_section.title
                  ? _c(
                      "h2",
                      { staticClass: "mt5 tc ttu f1 f-4-ns is-blenny is-red" },
                      [_vm._v(_vm._s(_vm.page.lineup_section.title))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row mt3 mt4-ns" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-12 mv2 mv3-ns" }, [
                    _c(
                      "a",
                      {
                        staticClass: "db relative pointer grow",
                        attrs: {
                          href: _vm.page.lineup_section.link,
                          target: "_blank",
                          title: _vm.page.lineup_section.title,
                        },
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: _vm.page.lineup_section.image,
                              expression: "page.lineup_section.image",
                            },
                          ],
                          attrs: {
                            title: _vm.page.lineup_section.title,
                            alt: _vm.page.lineup_section.title,
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page.watch_section && _vm.page.watch_section.is_published
          ? _c(
              "section",
              {
                staticClass: "db relative center mw8 pv3",
                attrs: { id: _vm.page.watch_section.id },
              },
              [
                _vm.page.lineup_section.title
                  ? _c(
                      "h2",
                      { staticClass: "mt5 tc ttu f1 f-4-ns is-blenny is-red" },
                      [_vm._v(_vm._s(_vm.page.watch_section.title))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass:
                      "db relative mt4 tc ttn f3 f2-ns is-tablet-semicond-bold lh-copy is-red pointer grow",
                    attrs: {
                      to: "/outside-lands-works/",
                      title: "Donations will benefit Outside Lands Works",
                    },
                  },
                  [
                    _vm._v(
                      "\n        Donations will benefit Outside Lands Works\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "db relative center mw8 mt4 pb3" }, [
                  _vm.page.intro_section.twitch_embed &&
                  _vm.page.intro_section.twitch_embed.is_published
                    ? _c("div", {
                        ref: "twitchEmbedContainer",
                        staticClass: "db relative center w-100",
                        attrs: { id: "twitch-embed-container" },
                      })
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page.merch_section && _vm.page.merch_section.is_published
          ? _c(
              "section",
              {
                staticClass: "db relative center mw7 pv3",
                attrs: { id: _vm.page.merch_section.id },
              },
              [
                _vm.page.merch_section.title
                  ? _c(
                      "h2",
                      { staticClass: "mt5 tc ttu f1 f-4-ns is-blenny is-red" },
                      [_vm._v(_vm._s(_vm.page.merch_section.title))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row middle-sm mt0 mt4-ns" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-6 ph0 pr3-ns" }, [
                    _c("img", {
                      staticClass:
                        "db relative center mt4 w-100 mw7 il-img-border",
                      attrs: { src: _vm.page.merch_section.image },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-sm-6 ph0 pl3-ns" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "flex relative center w-100 mw6-ns justify-center tc overflow-hidden f3 ttu pointer mt4 btn-green",
                        attrs: {
                          href: _vm.page.merch_section.cta_button.link,
                          title: _vm.page.merch_section.cta_button.link,
                          target: "_blank",
                        },
                      },
                      [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(
                            _vm._s(_vm.page.merch_section.cta_button.title)
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "db relative mt3 f3 lh-copy tc is-tablet-semicond-bold is-green",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.marked(_vm.page.merch_section.text)
                        ),
                      },
                    }),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page.news_section && _vm.page.news_section.is_published
          ? _c(
              "section",
              {
                staticClass: "db relative center mw8 pv3",
                attrs: { id: _vm.page.news_section.id },
              },
              [
                _vm.page.news_section.title
                  ? _c(
                      "h2",
                      { staticClass: "mt5 tc ttu f1 f-4-ns is-blenny is-red" },
                      [_vm._v(_vm._s(_vm.page.news_section.title))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row mt4" },
                  _vm._l(_vm.page.news_section.posts, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: "news-post-" + index,
                        staticClass: "col-xs-12 col-sm-6 mv4 mv3-ns ph0 ph3-ns",
                      },
                      [
                        item.is_link_out === true
                          ? _c(
                              "a",
                              {
                                staticClass: "db relative pointer grow",
                                attrs: {
                                  href: item.link,
                                  title: item.title,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy:background",
                                      value: item.image,
                                      expression: "item.image",
                                      arg: "background",
                                    },
                                  ],
                                  staticClass:
                                    "db relative bg-center-top news-zoom aspect-ratio--16x9 cover il-img-border",
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "mt2 f3 lh-copy tc is-tablet-semicond-bold ttu is-green",
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                                _vm._v(" "),
                                item.text
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mt2 f4 lh-copy tc is-tablet-semicond-bold is-green",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.marked(item.text)
                                          ),
                                        },
                                      },
                                      [_vm._v(_vm._s(item.text))]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "db relative center pointer grow",
                                attrs: { to: item.link, title: item.title },
                              },
                              [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy:background",
                                      value: item.image,
                                      expression: "item.image",
                                      arg: "background",
                                    },
                                  ],
                                  staticClass:
                                    "db relative bg-center-top news-zoom aspect-ratio--16x9 cover il-img-border",
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "mt2 f3 lh-copy tc is-tablet-semicond-bold ttu is-green",
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                                _vm._v(" "),
                                item.text
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mt2 f4 lh-copy tc is-tablet-semicond-bold is-green",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.marked(item.text)
                                          ),
                                        },
                                      },
                                      [_vm._v(_vm._s(item.text))]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page.partners_section && _vm.page.partners_section.is_published
          ? _c(
              "section",
              {
                staticClass: "db relative center mw8 pv3",
                attrs: { id: _vm.page.partners_section.id },
              },
              [
                _vm.page.partners_section.title
                  ? _c(
                      "h2",
                      { staticClass: "mt5 tc ttu f1 f-4-ns is-blenny is-red" },
                      [_vm._v(_vm._s(_vm.page.partners_section.title))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row middle-sm mt4" },
                  _vm._l(
                    _vm.page.partners_section.partner_images,
                    function (item, index) {
                      return item && item.is_published
                        ? _c(
                            "div",
                            {
                              key: "partner-image-" + index,
                              staticClass:
                                "col-xs-6 col-sm-2 center mv2 mv3-ns",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "db relative pointer grow",
                                  attrs: { href: item.link, target: "_blank" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "db relative bg-center-top aspect-ratio--1x1 bg-white il-img-border",
                                    },
                                    [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "lazy",
                                            rawName: "v-lazy",
                                            value: item.image,
                                            expression: "item.image",
                                          },
                                        ],
                                        staticClass:
                                          "db absolute center abs-vert-center w-100 mw100 ph2",
                                        attrs: { alt: item.title },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e()
                    }
                  ),
                  0
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(1),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dn relative center w-100 mw6" }, [
      _c(
        "h4",
        {
          staticClass: "absolute mv0 tc h1 w1 transparent",
          staticStyle: { color: "transparent" },
        },
        [_vm._v("Exclusively On Twitch")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      {
        staticClass: "db relative center mw8 pt5 pt6-ns",
        attrs: { id: "ol-works" },
      },
      [
        _c("div", {
          staticClass: "plg-donate",
          attrs: { "data-widget-id": "xsZJ7T2BtWPZdsf0VZa1tg" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }